import { PERMISSION } from '../../constants'

export const PermALL = [
  PERMISSION.ADMIN,
  PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.PRICING,
  PERMISSION.OP,
  PERMISSION.COORDINATION,
  PERMISSION.DRIVE,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

//Loại hình đơn hàng
export const Perm_OrderType_View = PermALL

export const Perm_OrderType_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_OrderType_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_OrderType_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Loại hình đóng gói
export const Perm_ShellType_View = PermALL

export const Perm_ShellType_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_ShellType_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_ShellType_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Phương tiện
export const Perm_CarType_View = PermALL

export const Perm_CarType_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_CarType_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_CarType_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Hãng tàu
export const Perm_ShippingLine_View = PermALL

export const Perm_ShippingLine_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_ShippingLine_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_ShippingLine_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Tiền tệ
export const Perm_Currency_View = PermALL

export const Perm_Currency_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Currency_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Currency_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Phương thức thanh toán
export const Perm_PaymentMethod_View = PermALL

export const Perm_PaymentMethod_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_PaymentMethod_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_PaymentMethod_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Loại nhân viên
export const Perm_StaffType_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN
]

export const Perm_StaffType_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_StaffType_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_StaffType_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Nhân viên
export const Perm_Staff_View = [
  PERMISSION.ADMIN,
  PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.COORDINATION
]

export const Perm_Staff_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Staff_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Staff_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Staff_Lock = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Staff_RePass = [PERMISSION.ADMIN, PERMISSION.GD]
export const Perm_Staff_Account_View = [PERMISSION.ADMIN, PERMISSION.GD]
export const Perm_Staff_ViewAccount = [PERMISSION.ADMIN, PERMISSION.GD]

//Yêu cầu
export const Perm_RequestOrder_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.PRICING,
  PERMISSION.OP,
  PERMISSION.COORDINATION
]

export const Perm_RequestOrder_Add = Perm_RequestOrder_View

export const Perm_RequestOrder_Edit = Perm_RequestOrder_View

export const Perm_RequestOrder_Delete = Perm_RequestOrder_View

//Giá cơ sở
export const Perm_PriceBase_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.PRICING
]

export const Perm_PriceBase_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.PRICING]

export const Perm_PriceBase_Edit = Perm_PriceBase_Add

export const Perm_PriceBase_Delete = Perm_PriceBase_Add

//Khách hàng
export const Perm_Customer_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.PRICING,
  PERMISSION.OP,
  PERMISSION.COORDINATION,
  //   PERMISSION.DRIVE,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Customer_View_Admin_General_Info = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH
]

export const Perm_Customer_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH]

export const Perm_Customer_Edit = Perm_Customer_Add

export const Perm_Customer_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Kỳ hạn thanh toán (Khách hàng)
export const Perm_Customer_PaymentTerm_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  //   PERMISSION.PRICING,
  //   PERMISSION.OP,
  //   PERMISSION.COORDINATION,
  //   PERMISSION.DRIVE,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Customer_PaymentTerm_Edit = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH]

//Quản lý kho (Khách hàng)
export const Perm_Customer_Warehouse_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.OP,
  PERMISSION.COORDINATION
]

export const Perm_Customer_Warehouse_Add = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES
]

export const Perm_Customer_Warehouse_Edit = Perm_Customer_Warehouse_Add

export const Perm_Customer_Warehouse_Delete = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH]

//Quản lý hợp đồng (Khách hàng)
export const Perm_Customer_Contract_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Customer_Contract_Add = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE
]

export const Perm_Customer_Contract_Edit = Perm_Customer_Contract_Add

export const Perm_Customer_Contract_Delete = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH]

//Tài khoản thanh toán (Khách hàng)
export const Perm_Customer_PaymentAccount_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Customer_PaymentAccount_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.TP_KE_TOAN]

export const Perm_Customer_PaymentAccount_Edit = Perm_Customer_PaymentAccount_Add

export const Perm_Customer_PaymentAccount_Close = Perm_Customer_PaymentAccount_Add

export const Perm_Customer_PaymentAccount_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Quản lý xe công ty/ lái xe

//Thông tin xe công ty
export const Perm_CarCompany_View = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]

export const Perm_CarCompany_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]

export const Perm_CarCompany_Edit = Perm_CarCompany_Add

export const Perm_CarCompany_Status = [...Perm_CarCompany_Add, PERMISSION.DRIVE]

export const Perm_CarCompany_Delete = Perm_CarCompany_Add

//Thông tin lái xe
export const Perm_Drive_View = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]

export const Perm_Drive_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]

export const Perm_Drive_Edit = Perm_Drive_Add

export const Perm_Drive_Delete = Perm_Drive_Add

//Định mức
export const Perm_Standard_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  // PERMISSION.PRICING,
  PERMISSION.OP,
  PERMISSION.COORDINATION,
  // PERMISSION.DRIVE,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Standard_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Standard_Edit = Perm_Standard_Add

export const Perm_Standard_Delete = Perm_Standard_Add

//History
export const Perm_GenusHistory_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  // PERMISSION.PRICING,
  PERMISSION.OP,
  PERMISSION.COORDINATION,
  // PERMISSION.DRIVE,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_GenusHistory_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]

export const Perm_GenusHistory_Edit = Perm_GenusHistory_Add

export const Perm_GenusHistory_Delete = Perm_GenusHistory_Add

//ĐƠN HÀNG
export const Perm_Order_Menu_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.OP
]

export const Perm_Order_Menu_View_Kt = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KE_TOAN
]

export const Perm_Order_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.OP,
  PERMISSION.COORDINATION,
  ...Perm_Order_Menu_View_Kt
]

export const Perm_Order_View_Kt = Perm_Order_Menu_View_Kt

export const Perm_Order_Connect = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES
]

export const Perm_Order_Upload_View = Perm_Order_View

export const Perm_Order_Upload_Add = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.OP
]

export const Perm_Order_Btn_Complate = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES
]

export const Perm_Order_Upload_Edit = Perm_Order_Upload_Add

//Màn thêm đơn hàng
export const Perm_Order_Add = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES
  // PERMISSION.CUSTOMER_SUPPORT,
  // PERMISSION.OP,
  // PERMISSION.COORDINATION
]

//Màn sửa đơn hàng
export const Perm_Order_Edit = [...Perm_Order_Add, PERMISSION.COORDINATION, PERMISSION.OP]

//Xem

export const Perm_Order_InfoBasic_View = Perm_Order_View

export const Perm_Order_InfoTransfer_View = Perm_Order_View

export const Perm_Order_InfoGoods_View = Perm_Order_View

export const Perm_Order_InfoCarCompany_View = Perm_Order_View

export const Perm_Order_InfoCarVendor_View = Perm_Order_View

export const Perm_Order_InfoSynthetic_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.OP
]

export const Perm_Order_RuCom_View = Perm_Order_InfoSynthetic_View

export const Perm_Order_FreightService_View = Perm_Order_InfoSynthetic_View //Vận chuyển

export const Perm_Order_CustomsClearanceService_View = Perm_Order_InfoSynthetic_View //Dịch vụ thông quan

export const Perm_Order_CashDisbursement_View = Perm_Order_InfoSynthetic_View //Chi hộ

export const Perm_Order_Invoice_View = Perm_Order_InfoSynthetic_View //Hoá đơn

//Thêm

export const Perm_Order_InfoBasic_Add = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES
]

export const Perm_Order_Vat_Cost = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Order_Vat = Perm_Order_Vat_Cost

export const Perm_Order_InfoTransfer_Add = Perm_Order_InfoBasic_Add

export const Perm_Order_InfoGoods_Add = Perm_Order_InfoBasic_Add

export const Perm_Order_InfoCarVendor_Add = Perm_Order_Add

export const Perm_Order_RuCom_Add = Perm_Order_InfoBasic_Add

export const Perm_Order_FreightService_Add = Perm_Order_Add //Vận chuyển

export const Perm_Order_CustomsClearanceService_Add = Perm_Order_Add //Dịch vụ thông quan

export const Perm_Order_CashDisbursement_Add = Perm_Order_Add //Chi hộ

export const Perm_Order_Invoice_Add = [...Perm_Order_InfoBasic_Add, PERMISSION.OP] //Hoá đơn

// export const Perm_Order_InfoCarCompayny_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]
export const Perm_Order_InfoCarCompany_Add = []

//Sửa

export const Perm_Order_InfoBasic_Edit = Perm_Order_InfoBasic_Add

export const Perm_Order_InfoGoods_Edit = Perm_Order_InfoGoods_Add

export const Perm_Order_InfoTransfer_Edit = Perm_Order_InfoTransfer_Add

export const Perm_Order_InfoCarVendor_Edit = Perm_Order_InfoCarVendor_Add

export const Perm_Order_InfoCarCompany_Edit = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]

export const Perm_Order_FreightService_Edit = Perm_Order_InfoBasic_Add //Vận chuyển

export const Perm_Order_CustomsClearanceService_Edit = Perm_Order_InfoBasic_Add //Dịch vụ thông quan

export const Perm_Order_CashDisbursement_Edit = Perm_Order_InfoBasic_Add //Chi hộ

export const Perm_Order_RuCom_Edit = Perm_Order_RuCom_Add

export const Perm_Order_Invoice_Edit = Perm_Order_Invoice_Add //Hoá đơn

// export const Perm_Order_Add = [
//   PERMISSION.ADMIN, PERMISSION.GD,
//   PERMISSION.TP_KINH_DOANH,
//   PERMISSION.TP_KE_HOACH,
//   PERMISSION.SALE,
//   PERMISSION.CUSTOMER_SERVICES
// ]

// export const Perm_Order_Edit = Perm_Order_Add

export const Perm_Order_Delete = Perm_Order_Add
export const Perm_Order_Lock = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KE_HOACH
]

//Lô hàng
export const Perm_Shipment_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.OP
]

export const Perm_Shipment_View_Kt = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KE_TOAN
]

export const Perm_Shipment_Add = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES
]

export const Perm_Shipment_Edit = Perm_Shipment_Add

export const Perm_Shipment_Delete = Perm_Shipment_Add

export const Perm_Shipment_InfoBasic_View = Perm_Shipment_View
export const Perm_Shipment_InfoBasic_Add = Perm_Shipment_Add
export const Perm_Shipment_InfoBasic_Edit = Perm_Shipment_Add

export const Perm_AddOrder_To_Shipment_View = Perm_Shipment_View
export const Perm_AddOrder_To_Shipment_Add = Perm_Shipment_Add
export const Perm_AddOrder_To_Shipment_Delete = Perm_Shipment_Add

//Điều phối

export const Perm_Order_TransportCoordination_View = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]
export const Perm_Order_FeesFormCompany_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.SALE,
  PERMISSION.CUSTOMER_SERVICES,
  PERMISSION.CUSTOMER_SUPPORT,
  PERMISSION.OP,
  PERMISSION.COORDINATION
]
export const Perm_Order_FeesFormCompany_Edit = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.COORDINATION]
export const Perm_Order_FeesFormCompany_Add = Perm_Order_FeesFormCompany_Edit

//Report
export const Perm_MenuReport_View = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.OP
]

export const Perm_Advance_View = [
  PERMISSION.ADMIN,
  PERMISSION.GD,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.OP,
  PERMISSION.COORDINATION
]

export const Perm_Advance_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.OP]

export const Perm_Advance_Edit = Perm_Advance_Add

export const Perm_Advance_Delete = Perm_Advance_View

export const Perm_Advance_Approve_1 = [PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH]

export const Perm_Advance_Approve_2 = [
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Advance_Approve_3 = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_OfferToPay_View = [
  PERMISSION.ADMIN,
  PERMISSION.GD,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.OP,
  PERMISSION.COORDINATION
]

export const Perm_OfferToPay_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.OP, PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH]

export const Perm_OfferToPay_Edit = Perm_OfferToPay_Add

export const Perm_OfferToPay_Delete = Perm_OfferToPay_View

export const Perm_OfferToPay_Approve_1 = [PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH, PERMISSION.COORDINATION]

export const Perm_OfferToPay_Approve_2 = [
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_OfferToPay_Approve_3 = [PERMISSION.ADMIN, PERMISSION.GD]

//Đề nghị thanh toán
export const Perm_Reimburse_View = [
  PERMISSION.ADMIN,
  PERMISSION.GD,
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH,
  PERMISSION.OP,
  PERMISSION.COORDINATION
]

export const Perm_Reimburse_Add = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.OP]

export const Perm_Reimburse_Edit = Perm_Reimburse_Add

export const Perm_Reimburse_Delete = Perm_Reimburse_View

export const Perm_Reimburse_Approve_1 = [PERMISSION.TP_KINH_DOANH, PERMISSION.TP_KE_HOACH]

export const Perm_Reimburse_Approve_2 = [
  PERMISSION.TP_KE_TOAN,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_TONG_HOP
]

export const Perm_Reimburse_Approve_3 = [PERMISSION.ADMIN, PERMISSION.GD]

//Location
export const Perm_Location_View = PermALL

export const Perm_Location_Add = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Location_Edit = [PERMISSION.ADMIN, PERMISSION.GD]

export const Perm_Location_Delete = [PERMISSION.ADMIN, PERMISSION.GD]

//Report Kế toán
export const Perm_Order_Report_Kt = [
  PERMISSION.ADMIN, PERMISSION.GD,
  PERMISSION.KE_TOAN_CONG_NO,
  PERMISSION.KE_TOAN_QUY,
  PERMISSION.KE_TOAN_TONG_HOP,
  PERMISSION.TP_KE_TOAN
]

//Tài chính & Lợi nhuận
export const Perm_MenuFinance_View = Perm_Order_Report_Kt
export const Perm_ProfitReport_View = [
  ...Perm_Order_Report_Kt,
  PERMISSION.TP_KINH_DOANH,
  PERMISSION.TP_KE_HOACH
]
export const Perm_CustomerDebt_View = Perm_Order_Report_Kt
export const Perm_CashBook_View = [PERMISSION.ADMIN, PERMISSION.GD, PERMISSION.TP_KE_TOAN, PERMISSION.KE_TOAN_QUY]
